import { render } from "./WykresyPaulina.vue?vue&type=template&id=e2bcfb18&ts=true"
import script from "./WykresyPaulina.vue?vue&type=script&lang=ts"
export * from "./WykresyPaulina.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__